export const FRAMES_CATALOG = [
  {
    frameId: 'frame-rect-01',
    title: 'Rectangle',
    subcategory: 'basic',
    tags: ['rect', 'square'],
    shapeType: 'rect',
    viewBox: '0 0 100 100',
    cornerRadius: 6,
    defaultSize: { width: 480, height: 360 },
    previewSvg:
      '<svg viewBox="0 0 100 100" fill="none" stroke="currentColor" stroke-width="6"><rect x="14" y="18" width="72" height="64" rx="8"/><rect x="28" y="32" width="44" height="36" rx="6" opacity="0.5"/></svg>',
  },
  {
    frameId: 'frame-rounded-02',
    title: 'Rounded',
    subcategory: 'basic',
    tags: ['rounded', 'card'],
    shapeType: 'rect',
    viewBox: '0 0 100 100',
    cornerRadius: 16,
    defaultSize: { width: 480, height: 360 },
    previewSvg:
      '<svg viewBox="0 0 100 100" fill="none" stroke="currentColor" stroke-width="6"><rect x="14" y="18" width="72" height="64" rx="18"/><rect x="30" y="34" width="40" height="32" rx="12" opacity="0.5"/></svg>',
  },
  {
    frameId: 'frame-soft-03',
    title: 'Soft Rounded',
    subcategory: 'basic',
    tags: ['soft', 'rounded'],
    shapeType: 'rect',
    viewBox: '0 0 100 100',
    cornerRadius: 28,
    defaultSize: { width: 480, height: 360 },
    previewSvg:
      '<svg viewBox="0 0 100 100" fill="none" stroke="currentColor" stroke-width="6"><rect x="14" y="18" width="72" height="64" rx="28"/><rect x="32" y="36" width="36" height="28" rx="16" opacity="0.5"/></svg>',
  },
  {
    frameId: 'frame-pill-04',
    title: 'Pill',
    subcategory: 'basic',
    tags: ['pill', 'capsule'],
    shapeType: 'rect',
    viewBox: '0 0 100 100',
    cornerRadius: 40,
    defaultSize: { width: 520, height: 240 },
    previewSvg:
      '<svg viewBox="0 0 100 100" fill="none" stroke="currentColor" stroke-width="6"><rect x="10" y="32" width="80" height="36" rx="18"/><rect x="26" y="40" width="48" height="20" rx="10" opacity="0.5"/></svg>',
  },
  {
    frameId: 'frame-circle-05',
    title: 'Circle',
    subcategory: 'basic',
    tags: ['circle', 'round'],
    shapeType: 'circle',
    viewBox: '0 0 100 100',
    defaultSize: { width: 420, height: 420 },
    previewSvg:
      '<svg viewBox="0 0 100 100" fill="none" stroke="currentColor" stroke-width="6"><circle cx="50" cy="50" r="34"/><circle cx="50" cy="50" r="20" opacity="0.5"/></svg>',
  },
  {
    frameId: 'frame-square-06',
    title: 'Square',
    subcategory: 'basic',
    tags: ['square'],
    shapeType: 'rect',
    viewBox: '0 0 100 100',
    cornerRadius: 8,
    defaultSize: { width: 420, height: 420 },
    previewSvg:
      '<svg viewBox="0 0 100 100" fill="none" stroke="currentColor" stroke-width="6"><rect x="18" y="18" width="64" height="64" rx="10"/><rect x="32" y="32" width="36" height="36" rx="6" opacity="0.5"/></svg>',
  },
  {
    frameId: 'frame-portrait-07',
    title: 'Portrait',
    subcategory: 'photo',
    tags: ['portrait', 'vertical'],
    shapeType: 'rect',
    viewBox: '0 0 100 140',
    cornerRadius: 10,
    defaultSize: { width: 420, height: 588 },
    previewSvg:
      '<svg viewBox="0 0 100 140" fill="none" stroke="currentColor" stroke-width="6"><rect x="14" y="16" width="72" height="108" rx="12"/><rect x="30" y="32" width="40" height="76" rx="8" opacity="0.5"/></svg>',
  },
  {
    frameId: 'frame-polaroid-08',
    title: 'Polaroid',
    subcategory: 'photo',
    tags: ['polaroid', 'photo'],
    shapeType: 'path',
    viewBox: '0 0 100 120',
    pathD: 'M12 8H88V112H12Z M22 18H78V86H22Z',
    defaultSize: { width: 460, height: 552 },
    previewSvg:
      '<svg viewBox="0 0 100 120" fill="none" stroke="currentColor" stroke-width="6"><path d="M12 8H88V112H12Z"/><path d="M22 18H78V86H22Z" opacity="0.5"/></svg>',
  },
  {
    frameId: 'frame-arch-09',
    title: 'Arch',
    subcategory: 'decor',
    tags: ['arch', 'rounded-top'],
    shapeType: 'path',
    viewBox: '0 0 100 130',
    pathD:
      'M18 54C18 30 34 12 50 12C66 12 82 30 82 54V118H18Z',
    defaultSize: { width: 440, height: 572 },
    previewSvg:
      '<svg viewBox="0 0 100 130" fill="none" stroke="currentColor" stroke-width="6"><path d="M18 54C18 30 34 12 50 12C66 12 82 30 82 54V118H18Z"/></svg>',
  },
  {
    frameId: 'frame-hexagon-10',
    title: 'Hexagon',
    subcategory: 'decor',
    tags: ['hexagon', 'polygon'],
    shapeType: 'path',
    viewBox: '0 0 100 100',
    pathD: 'M50 10L86 30V70L50 90L14 70V30Z',
    defaultSize: { width: 440, height: 440 },
    previewSvg:
      '<svg viewBox="0 0 100 100" fill="none" stroke="currentColor" stroke-width="6"><path d="M50 10L86 30V70L50 90L14 70V30Z"/></svg>',
  },
  {
    frameId: 'frame-diamond-11',
    title: 'Diamond',
    subcategory: 'decor',
    tags: ['diamond', 'kite'],
    shapeType: 'path',
    viewBox: '0 0 100 100',
    pathD: 'M50 6L94 50L50 94L6 50Z',
    defaultSize: { width: 420, height: 420 },
    previewSvg:
      '<svg viewBox="0 0 100 100" fill="none" stroke="currentColor" stroke-width="6"><path d="M50 6L94 50L50 94L6 50Z"/></svg>',
  },
  {
    frameId: 'frame-blob-12',
    title: 'Blob',
    subcategory: 'decor',
    tags: ['blob', 'organic'],
    shapeType: 'path',
    viewBox: '0 0 100 100',
    pathD:
      'M62 10C78 18 92 36 88 56C84 76 62 92 42 90C22 88 6 68 10 48C14 28 30 8 48 8C54 8 58 8 62 10Z',
    defaultSize: { width: 460, height: 460 },
    previewSvg:
      '<svg viewBox="0 0 100 100" fill="none" stroke="currentColor" stroke-width="6"><path d="M62 10C78 18 92 36 88 56C84 76 62 92 42 90C22 88 6 68 10 48C14 28 30 8 48 8C54 8 58 8 62 10Z"/></svg>',
  },
  {
    frameId: 'frame-ticket-13',
    title: 'Ticket',
    subcategory: 'decor',
    tags: ['ticket', 'notch'],
    shapeType: 'path',
    viewBox: '0 0 120 80',
    pathD:
      'M8 8H112V30C102 30 94 38 94 48C94 58 102 66 112 66V72H8V66C18 66 26 58 26 48C26 38 18 30 8 30V8Z',
    defaultSize: { width: 560, height: 360 },
    previewSvg:
      '<svg viewBox="0 0 120 80" fill="none" stroke="currentColor" stroke-width="6"><path d="M8 8H112V30C102 30 94 38 94 48C94 58 102 66 112 66V72H8V66C18 66 26 58 26 48C26 38 18 30 8 30V8Z"/></svg>',
  },
  {
    frameId: 'frame-phone-14',
    title: 'Phone Screen',
    subcategory: 'mock',
    tags: ['phone', 'mobile'],
    shapeType: 'path',
    viewBox: '0 0 90 160',
    pathD:
      'M18 6H72C78 6 84 12 84 18V142C84 148 78 154 72 154H18C12 154 6 148 6 142V18C6 12 12 6 18 6Z M32 18H58C60 18 62 20 62 22V26C62 28 60 30 58 30H32C30 30 28 28 28 26V22C28 20 30 18 32 18Z',
    defaultSize: { width: 360, height: 640 },
    previewSvg:
      '<svg viewBox="0 0 90 160" fill="none" stroke="currentColor" stroke-width="6"><rect x="8" y="8" width="74" height="144" rx="14"/><rect x="28" y="20" width="34" height="10" rx="4" opacity="0.6"/></svg>',
  },
  {
    frameId: 'frame-browser-15',
    title: 'Browser',
    subcategory: 'mock',
    tags: ['browser', 'window'],
    shapeType: 'path',
    viewBox: '0 0 120 80',
    pathD:
      'M8 12H112C116 12 120 16 120 20V72C120 76 116 80 112 80H8C4 80 0 76 0 72V20C0 16 4 12 8 12Z M0 28H120',
    defaultSize: { width: 640, height: 420 },
    previewSvg:
      '<svg viewBox="0 0 120 80" fill="none" stroke="currentColor" stroke-width="6"><rect x="4" y="12" width="112" height="64" rx="10"/><path d="M4 28H116"/><circle cx="18" cy="20" r="3"/><circle cx="30" cy="20" r="3"/><circle cx="42" cy="20" r="3"/></svg>',
  },
  {
    frameId: 'frame-pin-16',
    title: 'Pin',
    subcategory: 'decor',
    tags: ['pin', 'location'],
    shapeType: 'path',
    viewBox: '0 0 100 140',
    pathD:
      'M50 12C30 12 16 28 16 48C16 86 50 128 50 128C50 128 84 86 84 48C84 28 70 12 50 12Z M50 32C58 32 64 38 64 46C64 54 58 60 50 60C42 60 36 54 36 46C36 38 42 32 50 32Z',
    defaultSize: { width: 420, height: 588 },
    previewSvg:
      '<svg viewBox="0 0 100 140" fill="none" stroke="currentColor" stroke-width="6"><path d="M50 12C30 12 16 28 16 48C16 86 50 128 50 128C50 128 84 86 84 48C84 28 70 12 50 12Z"/><circle cx="50" cy="46" r="10" opacity="0.6"/></svg>',
  },
  {
    frameId: 'frame-speech-17',
    title: 'Speech Bubble',
    subcategory: 'decor',
    tags: ['speech', 'bubble'],
    shapeType: 'path',
    viewBox: '0 0 120 90',
    pathD:
      'M12 12H108C114 12 120 18 120 24V60C120 66 114 72 108 72H68L46 88V72H12C6 72 0 66 0 60V24C0 18 6 12 12 12Z',
    defaultSize: { width: 560, height: 420 },
    previewSvg:
      '<svg viewBox="0 0 120 90" fill="none" stroke="currentColor" stroke-width="6"><path d="M12 12H108C114 12 120 18 120 24V60C120 66 114 72 108 72H68L46 88V72H12C6 72 0 66 0 60V24C0 18 6 12 12 12Z"/></svg>',
  },
  {
    frameId: 'frame-star-18',
    title: 'Star',
    subcategory: 'decor',
    tags: ['star'],
    shapeType: 'path',
    viewBox: '0 0 100 100',
    pathD:
      'M50 8L62 36H92L68 56L78 88L50 68L22 88L32 56L8 36H38Z',
    defaultSize: { width: 440, height: 440 },
    previewSvg:
      '<svg viewBox="0 0 100 100" fill="none" stroke="currentColor" stroke-width="6"><path d="M50 8L62 36H92L68 56L78 88L50 68L22 88L32 56L8 36H38Z"/></svg>',
  },
  {
    frameId: 'frame-heart-19',
    title: 'Heart',
    subcategory: 'decor',
    tags: ['heart'],
    shapeType: 'path',
    viewBox: '0 0 110 100',
    pathD:
      'M55 90C55 90 10 62 10 34C10 18 22 6 38 6C48 6 54 12 55 18C56 12 62 6 72 6C88 6 100 18 100 34C100 62 55 90 55 90Z',
    defaultSize: { width: 460, height: 420 },
    previewSvg:
      '<svg viewBox="0 0 110 100" fill="none" stroke="currentColor" stroke-width="6"><path d="M55 90C55 90 10 62 10 34C10 18 22 6 38 6C48 6 54 12 55 18C56 12 62 6 72 6C88 6 100 18 100 34C100 62 55 90 55 90Z"/></svg>',
  },
  {
    frameId: 'frame-oval-20',
    title: 'Oval',
    subcategory: 'basic',
    tags: ['oval', 'ellipse'],
    shapeType: 'path',
    viewBox: '0 0 120 80',
    pathD: 'M60 8C30 8 8 26 8 40C8 54 30 72 60 72C90 72 112 54 112 40C112 26 90 8 60 8Z',
    defaultSize: { width: 540, height: 320 },
    previewSvg:
      '<svg viewBox="0 0 120 80" fill="none" stroke="currentColor" stroke-width="6"><path d="M60 8C30 8 8 26 8 40C8 54 30 72 60 72C90 72 112 54 112 40C112 26 90 8 60 8Z"/></svg>',
  },
  {
    frameId: 'frame-arch-wide-21',
    title: 'Wide Arch',
    subcategory: 'decor',
    tags: ['arch', 'wide'],
    shapeType: 'path',
    viewBox: '0 0 140 100',
    pathD:
      'M12 48C12 24 40 8 70 8C100 8 128 24 128 48V92H12Z',
    defaultSize: { width: 640, height: 460 },
    previewSvg:
      '<svg viewBox="0 0 140 100" fill="none" stroke="currentColor" stroke-width="6"><path d="M12 48C12 24 40 8 70 8C100 8 128 24 128 48V92H12Z"/></svg>',
  },
  {
    frameId: 'frame-arch-tall-22',
    title: 'Tall Arch',
    subcategory: 'decor',
    tags: ['arch', 'tall'],
    shapeType: 'path',
    viewBox: '0 0 100 160',
    pathD:
      'M14 78C14 36 32 12 50 12C68 12 86 36 86 78V148H14Z',
    defaultSize: { width: 420, height: 720 },
    previewSvg:
      '<svg viewBox="0 0 100 160" fill="none" stroke="currentColor" stroke-width="6"><path d="M14 78C14 36 32 12 50 12C68 12 86 36 86 78V148H14Z"/></svg>',
  },
  {
    frameId: 'frame-blob-23',
    title: 'Soft Blob',
    subcategory: 'decor',
    tags: ['blob', 'soft'],
    shapeType: 'path',
    viewBox: '0 0 100 100',
    pathD:
      'M54 6C76 10 96 30 92 54C88 78 60 94 36 92C12 90 -2 70 2 46C6 22 28 2 54 6Z',
    defaultSize: { width: 480, height: 480 },
    previewSvg:
      '<svg viewBox="0 0 100 100" fill="none" stroke="currentColor" stroke-width="6"><path d="M54 6C76 10 96 30 92 54C88 78 60 94 36 92C12 90 -2 70 2 46C6 22 28 2 54 6Z"/></svg>',
  },
  {
    frameId: 'frame-cut-corner-24',
    title: 'Cut Corner',
    subcategory: 'basic',
    tags: ['cut', 'corner'],
    shapeType: 'path',
    viewBox: '0 0 120 90',
    pathD: 'M12 8H92L112 28V82H12Z',
    defaultSize: { width: 560, height: 420 },
    previewSvg:
      '<svg viewBox="0 0 120 90" fill="none" stroke="currentColor" stroke-width="6"><path d="M12 8H92L112 28V82H12Z"/></svg>',
  },
  {
    frameId: 'frame-diamond-25',
    title: 'Diamond Tall',
    subcategory: 'decor',
    tags: ['diamond', 'tall'],
    shapeType: 'path',
    viewBox: '0 0 90 140',
    pathD: 'M45 6L84 70L45 134L6 70Z',
    defaultSize: { width: 420, height: 640 },
    previewSvg:
      '<svg viewBox="0 0 90 140" fill="none" stroke="currentColor" stroke-width="6"><path d="M45 6L84 70L45 134L6 70Z"/></svg>',
  },
  {
    frameId: 'frame-lens-26',
    title: 'Lens',
    subcategory: 'basic',
    tags: ['lens', 'circle'],
    shapeType: 'path',
    viewBox: '0 0 110 110',
    pathD:
      'M55 8C29 8 8 29 8 55C8 81 29 102 55 102C81 102 102 81 102 55C102 29 81 8 55 8Z M55 24C73 24 86 37 86 55C86 73 73 86 55 86C37 86 24 73 24 55C24 37 37 24 55 24Z',
    defaultSize: { width: 460, height: 460 },
    previewSvg:
      '<svg viewBox="0 0 110 110" fill="none" stroke="currentColor" stroke-width="6"><circle cx="55" cy="55" r="42"/><circle cx="55" cy="55" r="26" opacity="0.6"/></svg>',
  },
  {
    frameId: 'frame-slant-27',
    title: 'Slanted',
    subcategory: 'decor',
    tags: ['slant', 'angle'],
    shapeType: 'path',
    viewBox: '0 0 120 90',
    pathD: 'M18 8H112L102 82H8Z',
    defaultSize: { width: 560, height: 420 },
    previewSvg:
      '<svg viewBox="0 0 120 90" fill="none" stroke="currentColor" stroke-width="6"><path d="M18 8H112L102 82H8Z"/></svg>',
  },
  {
    frameId: 'frame-ribbon-28',
    title: 'Ribbon',
    subcategory: 'decor',
    tags: ['ribbon'],
    shapeType: 'path',
    viewBox: '0 0 130 70',
    pathD: 'M10 10H120V60L100 46L80 60L60 46L40 60L20 46L10 52Z',
    defaultSize: { width: 620, height: 320 },
    previewSvg:
      '<svg viewBox="0 0 130 70" fill="none" stroke="currentColor" stroke-width="6"><path d="M10 10H120V60L100 46L80 60L60 46L40 60L20 46L10 52Z"/></svg>',
  },
  {
    frameId: 'frame-capsule-29',
    title: 'Capsule',
    subcategory: 'basic',
    tags: ['capsule', 'pill'],
    shapeType: 'rect',
    viewBox: '0 0 120 70',
    cornerRadius: 26,
    defaultSize: { width: 600, height: 300 },
    previewSvg:
      '<svg viewBox="0 0 120 70" fill="none" stroke="currentColor" stroke-width="6"><rect x="8" y="14" width="104" height="42" rx="22"/><rect x="28" y="26" width="64" height="18" rx="9" opacity="0.6"/></svg>',
  },
  {
    frameId: 'frame-cutout-30',
    title: 'Cutout',
    subcategory: 'decor',
    tags: ['cutout', 'notch'],
    shapeType: 'path',
    viewBox: '0 0 120 100',
    pathD:
      'M12 12H108V40H88V60H108V88H12V60H32V40H12Z',
    defaultSize: { width: 580, height: 480 },
    previewSvg:
      '<svg viewBox="0 0 120 100" fill="none" stroke="currentColor" stroke-width="6"><path d="M12 12H108V40H88V60H108V88H12V60H32V40H12Z"/></svg>',
  },
];
